/**
 *将键值对转换为嵌套格式
 *
 * @param {object} before  只有一层的键值对
 * @returns {object} after  适配嵌套的文案引用格式
 **/
function formatAdapter(before) {
  before['creatework_submit'] = before['creatework_submit'] || before['submit'];
  before['mywork_headerTitle'] =
    before['mywork_headerTitle'] || before['mylist_headerTitle'];
  before['mywork_sendMessage'] = before['mywork_sendMessage'] || before['send'];
  before['mywork_goGame'] =
    before['mywork_goGame'] || before['creatework_goGame'];
  before['mywork_uploadTips'] =
    before['mywork_uploadTips'] || before['creatework_uploadTips'];
  if (before.formatted) {
    return before;
  }
  let after = {};
  let stratiges = {
    singleLayer: {
      reg: /(creatework|mylist|mywork|accountrecovery)\_\w+/gi,
      handler: function (key, val) {
        let path = key.split('_');
        if (!after[path[0]]) {
          after[path[0]] = {};
        }
        after[path[0]][`_${path[1]}`] = val;
        this.reg.lastIndex = -1;
      }
    },
    nested: {
      reg: /creatework\_\w+\_/gi,
      handler: function (key, val) {
        let path = key.split('_');
        if (!after.creatework._selectBox) {
          after.creatework._selectBox = {};
          after.creatework._selectBox.selectList = [];
        }
        if (path[2] === 'selectTile') {
          after.creatework._selectBox.selectTile = val;
        } else {
          after.creatework._selectBox.selectList.push(val);
        }
        this.reg.lastIndex = -1;
      }
    }
  };

  let keys = Object.keys(before);
  keys.forEach((val, i) => {
    stratiges.nested.reg.lastIndex = 0;
    stratiges.singleLayer.reg.lastIndex = 0;
    if (stratiges.nested.reg.test(val)) {
      /* eslint-disable  no-useless-call */
      stratiges.nested.handler.call(stratiges.nested, val, before[val]);
    } else if (stratiges.singleLayer.reg.test(val)) {
      /* eslint-disable  no-useless-call */
      stratiges.singleLayer.handler.call(
        stratiges.singleLayer,
        val,
        before[val]
      );
    }
    after[val] = before[val];
  });

  after.formatted = true;
  return after;
}
export default formatAdapter;
